
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/face-swap",
      function () {
        return require("private-next-pages/face-swap/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/face-swap"])
      });
    }
  